import React, { useEffect } from 'react';
import useTranslation from '../hooks/useTranslation';
import { useAppDispatch, useAppSelector } from '../hooks/sharedHooks';
import ActionToast from './ActionToast';
import { hideAccessDenied } from '../../public/accessDeniedSlice';

/**
 * Global toast notification shown when an authenticated user receives a 403 response.
 * Uses the accessDenied Redux state (shared with the public AccessDeniedNotification).
 * Place this component in the authenticated Layout.
 */
const PermissionDeniedNotification = () => {
  const { translate } = useTranslation('common');
  const dispatch = useAppDispatch();
  const { isAccessDenied, denialType } = useAppSelector((state) => state.accessDenied);

  useEffect(() => {
    if (isAccessDenied) {
      const timer = setTimeout(() => {
        dispatch(hideAccessDenied());
      }, 6000);

      return () => clearTimeout(timer);
    }
  }, [isAccessDenied, dispatch]);

  const handleClose = () => {
    dispatch(hideAccessDenied());
  };

  const getMessageKey = (): string => {
    if (denialType === 'role') return 'permissionDeniedRole';
    if (denialType === 'module') return 'permissionDeniedModule';
    return 'permissionDenied';
  };

  return (
    <ActionToast
      open={isAccessDenied}
      variant="error"
      message={translate(getMessageKey())}
      onClose={handleClose}
      duration={6000}
    />
  );
};

export default PermissionDeniedNotification;
